import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Stack,
  Image,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  ModalCloseButton,
} from "@chakra-ui/react";
import { Markup } from "interweave";
import TextBlock from "./TextBlock";

const Figure = (props) => {
  const { figure, title, caption } = props;
  const [isOpen, setIsOpen] = useState(false);

  if (!figure) return null;

  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <Stack>
        <Image src={figure} onClick={toggleOpen} cursor="zoom-in" />
        {title && (
          <Markup
            content={`<b>${
              title.startsWith("Figure") ? "" : "Figure 1."
            } ${title
              .replace("<p>", "")
              .replace("</p>", "")
              .replace(":", "")
              .replace(".", "")}:</b>`}
          />
        )}
        {caption && <TextBlock text={caption} isHtml />}
      </Stack>
      <Modal
        onClose={toggleOpen}
        size="full"
        isOpen={isOpen}
        scrollBehavior="inside"
      >
        <ModalOverlay />
        <ModalContent>
          {title ? (
            <ModalHeader>
              <Markup content={title} />
            </ModalHeader>
          ) : (
            "Figure 1."
          )}
          <ModalCloseButton />
          <ModalBody>
            <Image src={figure} />
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

Figure.propTypes = {
  figure: PropTypes.string.isRequired,
  title: PropTypes.string,
  caption: PropTypes.string,
};

Figure.defaultProps = {
  title: null,
  caption: null,
};

export default Figure;
